export function isObject(arg: any): arg is object {
  return arg !== null && typeof arg === 'object';
}
